import SocketClientTypes from "constants/socketClientTypes";
import { io } from "socket.io-client";

class WebSocketService {
  socket = null;
  pendingListeners = [];

  connect(accessToken) {
    const APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    this.socket = io(`${APP_API_BASE_URL}`, {
      auth: { accessToken, socketClientType: SocketClientTypes.APP_RECIPIENT },
      transports: ["websocket"],
    });

    this.socket.on("connect", () => {
      this.pendingListeners.forEach(({ event, callback }) => {
        this.socket.on(event, callback);
      });
      this.pendingListeners = [];
    });
  }

  emit(event, data) {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    } else {
      this.pendingListeners.push({ event, callback });
    }
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    } else {
      this.pendingListeners = this.pendingListeners.filter(
        (l) => l.event !== event || l.callback !== callback,
      );
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}

const webSocket = new WebSocketService();
export default webSocket;
